export const blogPosts = [
  {
    id: "automatisation-rapports-geotechniques-btp",
    title: "Rapports G1 : de 3‑4 h de rédaction à quelques secondes",
    excerpt: "Une PME d'études de sols rédigeait ses rapports G1 à la main. Un programme génère désormais un rapport complet de 40 pages en quelques secondes.",
    date: "2026-02-20",
    updated: "2026-10-07", // titre, chiffres et image revus
    readTime: "5 min",
    category: "Cas client",
    tags: ["automatisation", "BTP", "Python", "rapports", "outil sur mesure"],
    // Photo Unsplash, hébergée sur le site (WebP pour l'affichage, JPEG 1200×630 pour les partages).
    image: "/img/blog/rapports-g1.webp",
    ogImage: "https://autoria.dev/img/blog/rapports-g1.jpg",
    content: `## Le contexte

Mon client, une PME lyonnaise spécialisée dans les **études géotechniques**, réalise des études de sols pour des projets de construction. Chaque mission aboutit à un **rapport G1** (rapport d'étude géotechnique préalable) d'environ **40 pages**.

Ces rapports suivent un format standardisé mais contiennent des données spécifiques à chaque terrain étudié : informations parcellaires, contexte géologique, résultats d'analyse, recommandations techniques, cartes et annexes.

## Le problème

Avant mon intervention, la rédaction d'un rapport G1 représentait **plusieurs heures de travail manuel** par mission :

- Copier-coller les données client dans un template Word
- Insérer manuellement les données parcellaires et géologiques
- Mettre en forme les tableaux de résultats
- Ajouter les cartes et images aux bons emplacements
- Vérifier la cohérence du document

Avec **plusieurs missions par semaine**, l'équipe passait un temps considérable sur de la mise en forme plutôt que sur l'analyse technique — leur vraie valeur ajoutée.

Le risque d'erreurs de saisie était aussi élevé : un mauvais numéro de parcelle ou une donnée mal recopiée pouvait compromettre la crédibilité du rapport.

## La solution

J'ai développé une **API REST en Python** qui automatise tout le pipeline de génération :

**1. Réception des données**
L'API reçoit les données métier au format JSON : informations client, données parcellaires, observations géologiques, résultats d'analyse et images.

**2. Génération du document**
À partir du modèle Word existant du client (on ne change pas leurs habitudes), le programme remplit automatiquement chaque section : page de garde, sommaire, corps du rapport, tableaux, annexes.

**3. Enrichissement**
Les cartes géologiques, coupes de terrain et photographies sont insérées automatiquement aux bons emplacements avec le bon formatage.

**4. Export**
Le rapport Word final est généré en quelques secondes, prêt à être relu et envoyé au client.

### Stack technique

- **Python** pour le backend
- **python-docx** pour la génération de documents Word
- **FastAPI** pour l'API REST
- **SQL** pour la récupération des données en base

## Les résultats

| Métrique | Avant | Après |
|----------|-------|-------|
| Temps par rapport | 3-4 heures | Quelques secondes |
| Ressaisie à la main | À chaque rapport | Aucune |
| Rapports par semaine | 3-4 | La rédaction ne les limite plus |
| Gain de temps hebdomadaire | — | ~15 heures |

L'équipe **relit désormais le rapport au lieu de le rédiger**, et consacre ce temps à l'analyse technique.

## Ce qu'on en retient

Partir des fichiers et des modèles que l'équipe utilise déjà, structurer les données, puis automatiser tout ce qui se recopie à la main : c'est la même démarche que j'applique aujourd'hui aux équipes e-commerce, avec leurs Excel et leurs exports Amazon et Shopify.

**Ça vous parle ?** Réservez un appel de 30 minutes : on regarde ensemble ce qui se recopie encore à la main chez vous.`
  }
];
